import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const SmoothScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  useEffect(() => {
    const lenis = window.__lenis;
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el && lenis) lenis.scrollTo(el, { offset: -70 });
      else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};
